import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,_vm._b({staticClass:"input-search",staticStyle:{"font-size":"16px"},attrs:{"single-line":"","clearable":"","hide-details":"","outlined":"","dense":"","label":_vm.$t('kindergarten_list.search'),"prepend-inner-icon":"mdi-magnify","background-color":"#EEEEEE"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }